import { render, staticRenderFns } from "./DialogCategoria.vue?vue&type=template&id=17d0d854&"
import script from "./DialogCategoria.vue?vue&type=script&lang=js&"
export * from "./DialogCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports